import { useMemo } from "react";
import { matchPath, useLocation } from "react-router-dom";

import { useMediaQuery } from "@/hooks/use-media-query";

export interface PageHeaderTabItem {
  /** Rota da aba (absoluta). */
  to: string;
  label: string;
  disabled?: boolean;
  /** Tooltip, normalmente o motivo de a aba estar desabilitada. */
  title?: string;
}

export interface UsePageHeaderTabsOptions {
  /** Media query do modo mobile. Padrão: `(max-width: 48rem)` (`--ds-breakpoint-md`). */
  mobileQuery?: string;
}

const DEFAULT_MOBILE_QUERY = "(max-width: 48rem)";

/** Modo mobile (reaproveita `useMediaQuery`) e a aba da rota atual (a de rota mais longa que casa com a URL, também em sub-rotas, como o NavLink). */
export function usePageHeaderTabs(
  items: readonly PageHeaderTabItem[],
  { mobileQuery = DEFAULT_MOBILE_QUERY }: UsePageHeaderTabsOptions = {},
) {
  const isMobile = useMediaQuery(mobileQuery);
  const { pathname } = useLocation();

  const activeItem = useMemo(
    () =>
      items
        .filter((item) => !item.disabled && matchPath({ path: item.to, end: false }, pathname))
        .reduce<PageHeaderTabItem | null>(
          (best, item) => (best && best.to.length >= item.to.length ? best : item),
          null,
        ),
    [items, pathname],
  );

  return { isMobile, activeItem };
}
